import React from 'react';

const RefundReturnTerms = () => {
  return (
    <div className="container my-5">
      <div className="text-center mb-4">
        <h1 className="fw-bold">TeeBlanka.com - Returns & Refunds Policy</h1>
        <p className="text-muted">
          Effective Date: <strong>01.04.2025</strong><br />
          Website: <a href="https://www.teeblanka.com" target="_blank" rel="noopener noreferrer">www.teeblanka.com</a><br />
          Brand Name: <strong>Tee Blanka®</strong> (A brand under Jain Screen®)
        </p>
      </div>

      <section className="mb-5">
        <p className="mb-4">
          At <strong>Tee Blanka®</strong>, customer satisfaction is our top priority. Our Returns & Refunds Policy
          outlines the process and terms applicable to all purchases made through our website and payment gateway.
        </p>

        <div className="mb-4">
          <h5>1. Eligibility for Returns</h5>
          <ul>
            <li>Products that are <strong>custom-made, printed, or personalized</strong> cannot be returned unless they are defective, damaged, or incorrect.</li>
            <li>Standard (non-customized) products can be returned within <strong>7 days</strong> of delivery if found defective or not as described.</li>
            <li>Any damage or defect must be reported to <a href="mailto:support@teeblanka.com">support@teeblanka.com</a> within <strong>48 hours</strong> of receiving the item, with clear images or video proof.</li>
          </ul>
        </div>

        <div className="mb-4">
          <h5>2. Return Process</h5>
          <ol>
            <li>Contact our support team with your Order ID, reason for return, and photos/videos of the product.</li>
            <li>Once verified, we will provide you with a Return Authorization and pickup or return address details.</li>
            <li>The product must be returned unused, unwashed, and in its original packaging with all tags and accessories intact.</li>
            <li>Products returned without authorization will not be accepted or refunded.</li>
          </ol>
        </div>

        <div className="mb-4">
          <h5>3. Refund Process</h5>
          <ul>
            <li>After receiving and inspecting the returned item, we will initiate a refund within <strong>7–10 business days</strong>.</li>
            <li>Refunds will be processed only through the original payment method used at checkout.</li>
            <li>For prepaid orders, refunds will be credited back to your account or card. For COD orders, a bank transfer may be requested.</li>
            <li>Refund amount excludes shipping and handling charges unless the return is due to an error or defect from our side.</li>
            <li>In case of partial returns, only the product value of eligible items will be refunded.</li>
          </ul>
        </div>

        <div className="mb-4">
          <h5>4. Non-Returnable Items</h5>
          <ul>
            <li>Custom printed, sublimated, or embroidered garments.</li>
            <li>Bulk or corporate orders under B2B terms.</li>
            <li>Clearance or discounted sale items.</li>
            <li>Digital downloads or design files.</li>
          </ul>
        </div>

        <div className="mb-4">
          <h5>5. Exchange Policy</h5>
          <ul>
            <li>Exchanges are allowed only for size issues on selected standard products, subject to availability.</li>
            <li>Exchange requests must be raised within <strong>3 days</strong> of delivery.</li>
            <li>Reverse pickup and re-shipping charges may apply.</li>
          </ul>
        </div>

        <div className="mb-4">
          <h5>6. Defective or Wrong Product Delivery</h5>
          <p>
            If you receive a wrong or damaged item, <strong>Tee Blanka®</strong> will arrange a free replacement or full refund after verification.
            The defective product must be returned in its original packaging.
          </p>
        </div>

        <div className="mb-4">
          <h5>7. Cancellation Policy</h5>
          <ul>
            <li>Orders can be canceled only within <strong>12 hours</strong> of placement if not yet processed or printed.</li>
            <li>Once customization or production begins, cancellation is not permitted.</li>
            <li>A small cancellation fee may apply for online payment gateway processing.</li>
          </ul>
        </div>

        <div className="mb-4">
          <h5>8. Payment Gateway & Refund Compliance</h5>
          <ul>
            <li>All refunds are initiated through our authorized payment partner gateways (Zoho Payments / ICICI EazyPay, etc.).</li>
            <li>Refund timelines are subject to the respective gateway’s processing rules.</li>
            <li><strong>Tee Blanka®</strong> will not be responsible for any delay caused by the payment processor or your bank.</li>
          </ul>
        </div>

        <div className="mb-4">
          <h5>9. Contact for Returns & Refunds</h5>
          <p>For all return and refund-related issues, please contact:</p>
          <ul>
            <li>Email: <a href="mailto:admin@teeblanka.com">admin@teeblanka.com</a></li>
            <li>Phone: +91 93721 28222 / +91 93722 12922</li>
          </ul>
        </div>
      </section>

      <div className="text-center text-muted">
        <p>Thank you for shopping with <strong>Tee Blanka®</strong>!</p>
      </div>
    </div>
  );
};

export default RefundReturnTerms;
